// extracted by mini-css-extract-plugin
module.exports = {"video":"EditableVideo_video__3VjSA","iframe":"EditableVideo_iframe__2eKfT","externalURL":"EditableVideo_externalURL__2hT7h","poster":"EditableVideo_poster__2a0ua"};